module.exports = __webpack_public_path__ + "images/emoji/sparkler.dfaf30a7f1e9fff050bf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sparkler.png
// module id = qTif
// module chunks = 14